import {
  AcceptIssueStatus,
  CockpitMode,
  CockpitStatus,
  CockpitType,
} from '@/utils/type';
import { createAction, createSlice } from '@reduxjs/toolkit';
import {
  COCKPIT_INFO,
  COCKPIT_TEAM,
  GetCockpitStatus,
  MessageType,
  USER_INFO,
  EXIT_COCKPIT,
} from '../actions/common';
import { makeFetchSuccessActionType } from '@/utils/makeActionType';
import { HttpStatusCode } from '@/fetch/core/constant';
export const actionGetCockpitInfo = createAction<any>(COCKPIT_INFO);
export const actionExitCockpit = createAction(EXIT_COCKPIT);
export const actionRestIsInit = createAction('REST_ISINIT');
export interface CockpitItem {
  cockpitNumber?: string; //驾驶舱编号
  vehicleName?: string; //接管车辆编号
  cockpitUserName?: string; //用户名
  cockpitType: CockpitType; //驾舱类型
  cockpitStatus?: CockpitStatus; // 工作状态
}
export interface CommonState {
  isInit: boolean;
  isMqttConnected: boolean;
  cockpitTeamNumber?: string | null; // 驾舱团队编号
  cockpitTeamName?: string | null; // 驾驶团队名称
  cockpitNumber?: string; //座席编号
  cockpitMode?: CockpitMode | null; //坐席模式
  cockpitStatus?: CockpitStatus | null; // 坐席状态
  cockpitType?: CockpitType | null; // 坐席类型
  workTotal?: number; //工作中座舱数量
  restTotal?: number; //未工作座舱数量
  offlineTotal?: number; // 离线座舱数量
  userInfo?: {
    workTimeTotal?: number; // 今日历史工作时长
    workStartTime?: string | null; // 当次工作开始时间
    completeIssueCount?: number; //处理工单数
    lastCockpitNumber?: string; //上次座席编号
    acceptIssueStatus?: AcceptIssueStatus; //接单状态
  } | null;
  teamInfo?: {
    completeIssueCount?: number; // 处理工单数
    waitAcceptIssueCount?: number; //待处理工单数
    cockpitList?: CockpitItem[] | null;
  } | null;
}

const initState: CommonState = {
  isInit: true,
  isMqttConnected: false,
  cockpitNumber: '',
  cockpitTeamName: null,
  cockpitMode: null,
  cockpitStatus: null,
  cockpitType: CockpitType.COCKPIT_SEAT,
  userInfo: {
    workTimeTotal: 0, // 今日历史工作时长
    workStartTime: null,
    completeIssueCount: 0,
  },
  teamInfo: {
    completeIssueCount: 0,
    waitAcceptIssueCount: 0,
  },
};

const newCommon = createSlice({
  name: 'newCommon',
  initialState: initState,
  reducers: {
    setIsMqttConnected: (state, action) => {
      state.isMqttConnected = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(MessageType.CONF_INFO, (state: CommonState, action: any) => {
        const res = action.payload;
        const { confInfo } = res;
        state.cockpitNumber = confInfo.cockpitNo;
      })
      .addCase(
        makeFetchSuccessActionType(GetCockpitStatus),
        (state, action: any) => {
          const res = action.payload;
          if (res.code === HttpStatusCode.Success) {
            const {
              cockpitType,
              cockpitTeamNumber,
              cockpitStatus,
              cockpitMode,
              cockpitNumber,
            } = res?.data || {};
            if (
              cockpitType === CockpitType.MONITOR_SEAT ||
              (cockpitNumber && cockpitNumber !== state.cockpitNumber)
            ) {
              return;
            }
            state.cockpitTeamNumber = cockpitTeamNumber;
            state.cockpitStatus = cockpitStatus;
            state.cockpitMode = cockpitMode;
            state.cockpitStatus = cockpitStatus;
          }
        }
      )
      .addCase(actionGetCockpitInfo, (state, action: any) => {
        const res = action.payload;
        state.cockpitTeamNumber = res?.cockpitTeamNumber;
        state.cockpitStatus = res?.cockpitStatus;
        state.cockpitMode = res?.cockpitMode;
      })
      .addCase(USER_INFO, (state, action: any) => {
        const res = action.payload;
        const {
          cockpitNumber,
          cockpitType,
          cockpitStatus,
          cockpitMode,
          ...otherData
        } = res?.data || {};
        if (
          cockpitType === CockpitType.MONITOR_SEAT ||
          (cockpitNumber && cockpitNumber !== state.cockpitNumber)
        ) {
          // message.error('您已入座其他座席，请退出座席后再重新入座');
          return;
        }
        state.cockpitStatus = cockpitStatus;
        state.cockpitMode = cockpitMode;
        state.userInfo = otherData;
      })
      .addCase(COCKPIT_TEAM, (state, action: any) => {
        const res = action.payload;
        const { data } = res || {};
        const { cockpitTeamName, cockpitTeamNumber, ...otherData } = data || {};
        state.cockpitTeamName = cockpitTeamName;
        state.cockpitTeamNumber = cockpitTeamNumber;
        state.teamInfo = otherData;
      })
      .addCase(actionExitCockpit, (state, action: any) => {
        state.cockpitMode = null;
        state.cockpitStatus = null;
      })
      .addCase(actionRestIsInit, (state, action: any) => {
        state.isInit = false;
      });
  },
});

export default newCommon.reducer;
